(function () {
  'use strict';

  // Load marker — check `window.__odditFilterSidebar` in the console to confirm
  // this script executed on the page.
  window.__odditFilterSidebar = true;

  var OPEN_CLASS = 'is-open';
  var SIDEBAR_SELECTOR = '.oddit-section-filter-sidebar';

  function getSidebar() {
    return document.querySelector(SIDEBAR_SELECTOR + '[data-filter-sidebar]');
  }

  // This theme wraps the page in an mmenu `.mm-slideout` element that carries a
  // CSS transform. A transformed ancestor makes `position: fixed` resolve
  // against that ancestor (not the viewport), which traps/clips the drawer.
  // Moving the drawer to be a direct child of <body> escapes the transform so
  // the fixed positioning and z-index work as intended.
  function portalSidebar() {
    var sidebars = document.querySelectorAll(SIDEBAR_SELECTOR + '[data-filter-sidebar]');
    if (!sidebars.length) return;
    var sidebar = sidebars[sidebars.length - 1];
    // Drop any stale duplicates left behind by a theme-editor re-render.
    for (var i = 0; i < sidebars.length - 1; i++) {
      if (sidebars[i] !== sidebar && sidebars[i].parentNode) {
        sidebars[i].parentNode.removeChild(sidebars[i]);
      }
    }
    if (sidebar.parentNode !== document.body) {
      document.body.appendChild(sidebar);
    }
  }

  function openSidebar() {
    var sidebar = getSidebar();
    if (!sidebar) return;
    sidebar.classList.add(OPEN_CLASS);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    var sidebar = getSidebar();
    if (!sidebar) return;
    sidebar.classList.remove(OPEN_CLASS);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  // Live-update the Apply button's product count as filters are ticked, without
  // reloading the page. Re-renders this section with the pending filter params
  // via the Section Rendering API and copies the freshly-computed count over.
  // The actual grid still updates on Apply (full reload).
  var countTimer = null;
  var countToken = 0;

  function updateCount() {
    var sidebar = getSidebar();
    if (!sidebar) return;
    var form = sidebar.querySelector('[data-filter-sidebar-form]');
    var applyText = sidebar.querySelector('[data-filter-sidebar-apply] span');
    var sectionId = sidebar.getAttribute('data-section-id');
    var collectionUrl = sidebar.getAttribute('data-collection-url');
    if (!form || !applyText || !sectionId || !collectionUrl) return;

    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '' && value != null) params.append(key, value);
    });
    params.set('section_id', sectionId);

    var token = ++countToken;
    applyText.parentNode.setAttribute('aria-busy', 'true');

    fetch(collectionUrl + '?' + params.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (token !== countToken) return; // a newer request superseded this one
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-filter-sidebar-apply] span');
        if (fresh) applyText.textContent = fresh.textContent;
      })
      .catch(function () {})
      .then(function () {
        if (applyText.parentNode) applyText.parentNode.removeAttribute('aria-busy');
      });
  }

  function scheduleCountUpdate() {
    clearTimeout(countTimer);
    countTimer = setTimeout(updateCount, 350);
  }

  // Delegated so the header's filter button (a separate section) and the
  // sidebar's own close/overlay controls all work without per-section wiring.
  // Collapsible groups are native <details>; Apply is a native form submit;
  // Reset is a plain link — so no JS is needed for those.
  // Capture phase so the trigger fires before any theme handler that might
  // stop propagation. `e.target` can be an SVG child, so guard closest().
  document.addEventListener(
    'click',
    function (e) {
      var node = e.target;
      if (!node || typeof node.closest !== 'function') return;
      if (node.closest('[data-collection-filters-toggle]')) {
        e.preventDefault();
        openSidebar();
        return;
      }
      if (node.closest('[data-filter-sidebar-close]')) {
        e.preventDefault();
        closeSidebar();
      }
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var sidebar = getSidebar();
      if (sidebar && sidebar.classList.contains(OPEN_CLASS)) {
        closeSidebar();
      }
    }
  });

  // Recompute the live count whenever a filter input changes (checkboxes fire
  // 'change'; price fields fire 'input'). Debounced.
  function onFilterChange(e) {
    if (e.target.closest && e.target.closest('[data-filter-sidebar-form]')) {
      scheduleCountUpdate();
    }
  }
  document.addEventListener('change', onFilterChange);
  document.addEventListener('input', onFilterChange);

  // Move the drawer out of the transformed page wrapper on load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portalSidebar);
  } else {
    portalSidebar();
  }

  // Re-portal and reset the scroll lock if the section is re-rendered.
  document.addEventListener('shopify:section:load', function () {
    portalSidebar();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  });
})();
